import e, { css as o } from "styled-components";
const i = e.div.withConfig({
  displayName: "Select",
  componentId: "sc-ek6svq-0"
})(["position:relative;width:", ";", " .react-select__group-heading{text-transform:none;}"], ({
  block: t
}) => t ? "100%" : "fit-content", ({
  disabled: t
}) => t && o(["cursor:not-allowed !important;opacity:0.4;pointer-events:all !important;"]));
export {
  i as Select
};
//# sourceMappingURL=style.es.js.map
